export const convertBytesToString = bytes => {
    if(bytes<1000)
    {
        return `${bytes} B`;
    }
    else if(bytes<1000000)
    {
        return `${Math.round(bytes/1000)} KB`;
    }
    else if(bytes<1000000000){
        return `${Math.round(bytes/1000000)} MB`
    }
}